import {pipe} from "mu-lambda";

import {type UrlRule} from "../types.ts";

import {defaultParam} from "./default-param.ts";
import {extractParamFromCurrentValue} from "./extract-param-from-current-value.ts";

/**
 * Initialize the continue query param.
 *
 * A continue query param is used to provide a URL to redirect to after
 * a certain action is completed, such as logging in. This rule will
 * initialize the continue query param to the current URL if it is not
 * already set. If it is already set, it will extract the continue param
 * value from the currently set value, if there is one, and use that.
 *
 * @param paramName The name of the param to use as the continue param.
 * Defaults to "continue".
 * @returns A URL rule that defaults the given param to the current URL, if
 * it is not already set, then extracts the the same param from that URL
 * if it is there.
 */
export const initializeContinueParam = (
    paramName: string = "continue",
): UrlRule =>
    pipe(
        defaultParam(
            paramName,
            () => location.pathname + location.search + location.hash,
        ),
        extractParamFromCurrentValue(paramName),
    );
